module.exports = __webpack_public_path__ + "static/6-8ef7c5f8b76928de3a6f0d5dc3aa99f7.jpg";